/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, Input, OnInit } from '@angular/core';
import { TaskDataBool } from '../../../../../../../models/task.model';

@Component({
  selector: 'app-boolean-item',
  templateUrl: './boolean-item.component.html',
  styleUrls: ['./boolean-item.component.scss'],
  standalone: false
})
export class BooleanItemComponent implements OnInit {
  @Input() booleanItem: TaskDataBool = new TaskDataBool(true);

  constructor() {}

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {}
}
